import React, {useState, useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { AcceptButton, CancelButton } from 'src/pages/components/Button';
import {updateAuctionTypeBidding} from 'src/api/product/bidding';
import { Global } from 'src/GlobalClass';

const TYPES = [
  {
    key: 'EBAY',
    value: 'Ebay',
  },
  {
    key: 'FLASHBID',
    value: 'Flash Bid',

  }
]


const UpdateBiddingAuctionTypeModal = ({
  isShow,
  onHide,
  bidding,
  onSuccess,
}) => {
  const [auctionType, setAuctionType] = useState(bidding.auctionType);

  useEffect(() => {
    if (bidding) {
      setAuctionType(bidding.auctionType);
    }
  }, [bidding]);

  const onConfirm = async () => {
    try {
      if (!auctionType) {
        Global.error({message: 'Loại đấu giá không hợp lệ'});
        return;
      }
      const result = await updateAuctionTypeBidding({
        auctionType,
        productId: bidding.productId,
      })
      if (result.responseCode.toString().startsWith('2')) {
        Global.success({message: 'Cập nhật loại đấu giá thành công'});
        onSuccess();
        resetDataModal();
      }
      else Global.error({message: result.responseText || 'Cập nhật loại đấu giá thất bại'})
    }
    catch (err) {
      Global.error({message: err.message || ''})
    }
  }

  const resetDataModal = () => {
    setAuctionType('');
  }

  const onCloseModal = () =>{
    resetDataModal();
    onHide();
  }

  return <Modal
    className='review-product-modal'
    show={isShow}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    scrollable
    animation
    onHide={onCloseModal}
  >
    <Modal.Header closeButton>
      <Modal.Title style={{ fontWeight: 'bold' }} id="contained-modal-title-vcenter">
        Cập nhật loại đấu giá {bidding ? bidding.productName : ''}
      </Modal.Title>
    </Modal.Header>

    <Modal.Body style={{ maxHeight: '65vh', overflow: 'scroll' }}>
      <div className="" style={{margin: 32}} >
        <label className="bmd-label-floating" style={{marginRight: 16, width: '15%'}}>Loại đấu giá</label>
        <select name="event" value={auctionType}
          onChange={e => {
            setAuctionType(e.target.value)
          }}
          style={{ padding: 5, width: '40%' }}
        >
            {TYPES.map(c => <option value={c.key} key={c.key} >{c.value}</option>)}
        </select>
      </div>
      
    </Modal.Body>
    <Modal.Footer>           
      <div>
          <CancelButton onClick={onCloseModal} title='Huỷ' />
          <AcceptButton onClick={onConfirm} title='Gửi' />
      </div>
    </Modal.Footer>
  </Modal>
}

export default UpdateBiddingAuctionTypeModal;